import { Route, Routes } from 'react-router-dom';
import ConverterNew from '../../../pages/manage_database/ConverterNew';
import ConverterChoice from '../../../pages/manage_database/ConverterChoice';
import ConverterDelete from '../../../pages/manage_database/ConverterDelete';
import ConverterRecord from '../../../pages/manage_database/ConverterRecord';


const ConverterRoutes = () => {
    return <Routes>
         <Route 
            path='/new'
            element={<ConverterNew />}
          />
          <Route 
            path='/choice'
            element={<ConverterChoice />}
          />
          <Route 
            path='/delete'
            element={<ConverterDelete />}
          />
          <Route 
            path='/record/:converter_id'
            element={<ConverterRecord />}
          />
    </Routes>
}

export default ConverterRoutes;